<div class="col-xs-12" class="not-found-page-container">
  Your current role  {{ currentRole }} does not have permission to view {{ currentUrl }} page.<br>
  Switch to a different role or ask your manager to request new roles for you.<br>
  <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLScR3Nggwu6Ha3QmJK7PA-oeGiMmqVkGYizoEOrzxXSJfY7owg/viewform">
    Click here if your manager's email ends with @fundingsocieties.com
  </a><br>
  <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSftY3on--59cezi9JL0VYpJA_3J8EedceDYCMAbQ3lORE1VcQ/viewform">
    Click here if your manager's email ends with @modalku.co.id</a>
</div>
